import React from "react";
import styled from "styled-components";

const Container = styled.span`
  font-size: 0.8em;
  font-weight: 600;
  margin-right: 8px;
`;

export default ({ children }) => {
  return <Container>[{children}]</Container>;
};
